/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import MagazineHeaderCard from "../../../../arrow-components/src/components/Rows/MagazineHeaderCard";
import MagazineEditions from "../../../../arrow-components/src/components/Rows/MagazineEditions";
import { getCollectionTemplate } from "../../get-collection-template";
import { getDefaultStoriesCount } from "../../../utils";
import isEmpty from "lodash/isEmpty";
import "./magazine-page.m.css";

const getCollectionStories = (firstEditionCollection, config, layout, storiesStartIndex) => {
  const storiesCount = parseInt(config.initialLoadCount) || getDefaultStoriesCount(layout);
  const storiesEndIndex = storiesStartIndex + storiesCount;
  const collectionItems = firstEditionCollection.items.slice(storiesStartIndex, storiesEndIndex);
  storiesStartIndex = storiesStartIndex + storiesCount;
  return {
    ...firstEditionCollection,
    items: collectionItems,
    currentOffset: storiesStartIndex
  };
};

const MagazineCollection = props => {
  const { layout, ...restProps } = props;
  const Component = getCollectionTemplate(layout);
  return React.createElement(Component, { ...restProps });
};
MagazineCollection.propTypes = {
  layout: PropTypes.string
};

export const MagazinePage = ({ data = {}, config = {} }) => {
  const { topStoriesCollection, allStoriesCollection, magazineSlug = "" } = data;
  const firstEdition = get(data, ["firstEdition", "collection"]);
  if (!firstEdition) return <div styleName="info-message">No editions found.</div>;

  const otherEditions = get(data, ["otherEditions"], []);
  const firstEditionCollection = get(data, ["firstEditionCollection", "collection"], {});
  const magazineRows = get(config, ["pagebuilder-config", "magazine", "rows"], []);
  if (!magazineRows.length) return <div styleName="info-message">Magazine configuration is missing.</div>;

  let storiesStartIndex = 0;
  return (
    <>
      {magazineRows.map(row => {
        const { name, layout, config } = row;
        switch (name) {
          case "headerEdition":
            config.customUrlPath = config.customUrlPath || `/subscription?group=${magazineSlug}`;
            return (
              <div className="container">
                <MagazineHeaderCard key={name} collection={firstEdition} config={config} />
              </div>
            );
          case "otherEditions":
            if (otherEditions.length)
              return (
                <div className="container">
                  <MagazineEditions key={name} data={otherEditions} config={config} />
                </div>
              );
            break;
          case "topStories":
          case "allStories":
            let collection = {};
            const rowCollection = name === "topStories" ? topStoriesCollection : allStoriesCollection;
            if (!isEmpty(rowCollection.collection)) {
              collection = rowCollection.collection;
            } else {
              collection = getCollectionStories(firstEditionCollection, config, layout, storiesStartIndex);
              storiesStartIndex = collection.currentOffset;
            }
            return <MagazineCollection key={name} collection={collection} layout={layout} metadata={{ config }} />;
        }
      })}
    </>
  );
};

MagazinePage.propTypes = {
  data: PropTypes.shape({
    firstEdition: PropTypes.shape({
      collection: PropTypes.object
    }),
    otherEditions: PropTypes.array,
    firstEditionCollection: PropTypes.shape({
      collection: PropTypes.object
    })
  }),
  config: PropTypes.shape({
    "pagebuilder-config": PropTypes.shape({
      magazine: PropTypes.shape({
        rows: PropTypes.array
      })
    })
  })
};
